import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import M from 'materialize-css';
import { compose } from 'redux';
import { firestoreConnect } from 'react-redux-firebase';
import JSONPretty from 'react-json-pretty';
import Form from '@rjsf/material-ui';
import { formSchema } from './schema';
import { schemaExample } from './schemaExample';
import JSONInput from 'react-json-editor-ajrm';
import locale from 'react-json-editor-ajrm/locale/en';
import Functions from '../../api/Functions';

function NewDatabase(props) {
  const [isLoading, setIsLoading] = useState(false);
  const [formSchemaValue, setFormSchemaValue] = useState({});
  const [jsonSchemaValue, setJsonSchemaValue] = useState();
  const [redirectToDatabaseList, setRedirectToDatabaseList] = useState(false);
  const { schemaToClone } = props;
  const dbName = useRef(null);
  const lastDoc = useRef(0);

  useEffect(() => M.AutoInit(), []);

  useEffect(() => {
    if (schemaToClone !== undefined) {
      const schemaObj = JSON.parse(schemaToClone);
      delete schemaObj.creationDate;
      delete schemaObj.databaseName;
      setFormSchemaValue(schemaObj);
      setJsonSchemaValue(schemaObj);
    }
  }, [schemaToClone]);

  const createDatabase = (schema) => {
    setIsLoading(true);
    Functions.createDatabaseCall(JSON.stringify(schema))
      .then(() => {
        M.toast({ html: `Database file created` });
        setIsLoading(false);
        setRedirectToDatabaseList(true);
      })
      .catch((e) => {
        setIsLoading(false);
        M.toast({ html: `Error: ${e.message}` });
      });
  };

  const createPynsDB = (schema) => {
    setIsLoading(true);
    Functions.createPynsDBInBatches(JSON.stringify(schema), dbName.current, lastDoc.current)
      .then(({ data }) => {
        if (data.finished) {
          M.toast({ html: `Database file created` });
          setRedirectToDatabaseList(true);
        } else {
          lastDoc.current = data.lastDoc;
          dbName.current = data.dbName;
        }
      })
      .catch((e) => M.toast({ html: `Error: ${e.message}` }))
      .finally(() => setIsLoading(false));
  };

  const handleSubmit = ({ formData }) => {
    formData.collections.forEach((item, index) => {
      if (isEmpty(item.filter)) {
        delete item.filter;
      }
    });
    setFormSchemaValue(formData);
    createDatabase(formData);
  };

  const isEmpty = (inputObject) => Object.keys(inputObject).length === 0;

  const { auth } = props;
  if (!auth.uid) return <Redirect to="/signin" />;
  if (redirectToDatabaseList) return <Redirect to="/databases" />;

  return (
    <div className="container">
      <div className="card z-depth-2 project-summary">
        <div className="card-content">
          <h4>New Database</h4>
          <div className="col s12">
            <ul className="tabs">
              <li className="tab col s3">
                <a className="active" href="#jsonTab">
                  Enter json
                </a>
              </li>
              <li className="tab col s3">
                <a href="#formTab">Use form</a>
              </li>
            </ul>
          </div>
          <div id="jsonTab" className="col s12">
            <div className="row">
              <div className="col s6">
                <h6>Schema json editor</h6>
                <JSONInput
                  onChange={(data) => {
                    setJsonSchemaValue(data.jsObject);
                  }}
                  placeholder={jsonSchemaValue}
                  theme="light_mitsuketa_tribute"
                  locale={locale}
                  height="550px"
                  width="500px"
                />
              </div>
              <div className="col s6">
                <h6>Schema example</h6>
                <div className="scheme-container-large">
                  <JSONPretty id="json-pretty" data={schemaExample}></JSONPretty>
                </div>
              </div>
            </div>
            <button className="waves-effect waves-light btn" onClick={() => createDatabase(jsonSchemaValue)} style={{marginRight: 15}}>
              Create
            </button>
            <button className="waves-effect waves-light btn" onClick={() => createPynsDB(jsonSchemaValue)} disabled={jsonSchemaValue && jsonSchemaValue.collections && (jsonSchemaValue.collections.length > 1 || jsonSchemaValue.collections[0].collection !== 'pyns')}>
              Upload pyns batch
            </button>
            <div className="progress" style={{ visibility: isLoading ? 'visible' : 'hidden' }}>
              <div className="indeterminate"></div>
            </div>
          </div>
          <div id="formTab" className="col s12">
            <Form schema={formSchema} formData={formSchemaValue} onSubmit={handleSubmit} onChange={({ formData }) => setFormSchemaValue(formData)} noHtml5Validate />
            <div className="progress" style={{ visibility: isLoading ? 'visible' : 'hidden' }}>
              <div className="indeterminate"></div>
            </div>
          </div>
        </div>
      </div>

      <div className="card-action"></div>
    </div>
  );
}

const mapStateToProps = (state, ownProps) => {
  return {
    auth: state.firebase.auth,
    schemaToClone: ownProps.location.schemaToClone,
  };
};

export default compose(firestoreConnect(), connect(mapStateToProps))(NewDatabase);
